import PhoneBrValidator from 'br-phone-validator-lib'

class PhoneValidatorAdapter {
  isValid (phoneNumber) {
    return PhoneBrValidator.isPhone(phoneNumber)
  }
}

export default PhoneValidatorAdapter
